import { DateTimeProperty } from "./DateTimeProperty";

import dayjs, { OpUnitType } from "dayjs";
dayjs.extend(require("dayjs/plugin/timezone"));

export class DateProperty extends DateTimeProperty {
  public displayFormat: string = "M/D/YYYY";

  public coerceValue(val: unknown): any {
    if (!val) return null;

    // A stored date whose components are out of range (a MySQL zero-date, or a
    // legacy value like 2024-02-30) parses leniently and silently rolls over
    // into a different, valid-looking date. Reject it rather than corrupt it.
    if (DateTimeProperty.hasOutOfRangeDate(val)) return null;

    // An unparseable input yields a truthy-but-invalid dayjs object; letting it
    // into the model makes serializedValueGuarded throw on toISOString
    // (Sentry GYROTONIC-DB-CLIENT-1E). Reject it at the funnel instead.
    const parsed = dayjs.utc(val as string);
    return parsed.isValid() ? parsed : null;
  }

  protected static compareResolution: OpUnitType = "day";

  public serializedValueGuarded(visited = new WeakSet<any>()): any {
    return this.value ? this.value.toISOString().substr(0, 10) : this.value;
  }
}
